import { requester } from "App";
import { mobileNoFormat, passwordFormat, textFormat, userNameFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputPassword from "components/inputs/signUp/InputPassword";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { validateInputs } from "shared/utils/Utils";
import styles from "./PartnersRegister.module.css";

function PartnersRegister() {
    const inputs = useRef([]);
    const { t } = useTranslation();
    const [duplicateCheck, setDuplicateCheck] = useState(true);
    const id = 'root';
    const dispatch = useDispatch();

    const onDuplicateClick = () => {
        let data = { userName: "", storeId: id, role: "PARTNERS" }
        data.userName = inputs.current[0].getValue();
        // 먼저 형식 유효성 검사를 수행합니다.
        const isFormatValid = userNameFormat.exp.test(data.userName);
        if (!isFormatValid) {
            toast.error("올바른 아이디를 입력해주세요", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            inputs.current[0].focus();
            return;
        }
        
        requester.duplicateCheck(data, (result) => {
            if (result.data) {
                toast.error("이미 사용중인 아이디입니다", {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });

                inputs.current[0].focus();
                setDuplicateCheck(result.data);
            } else {
                toast.success(t("available"), {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
                setDuplicateCheck(result.data);
            }
        });
    }

    const signUp = () => {
        let data = { storeId: id, userName: "", password: "", mobileNumber: "", email: "", storeCode: "" }
        let addressData = { address: "", addressDetail: "", zipcode: "" }

        if (!duplicateCheck) {
            validateInputs(inputs.current).then((isValid) => {
                if (isValid) {
                    // 유효성 검사를 통과하면, 입력 필드로부터 값을 가져와 data 객체를 업데이트
                    data.userName = inputs.current[0].getValue();
                    data.password = inputs.current[1].getValue();
                    data.mobileNumber = inputs.current[2].getValue();
                    data.storeName = inputs.current[3].getValue();
                    data.storeCode = inputs.current[4].getValue();

                    dispatch(HistoryReducer.actions.setLoading(true));
                    requester.partnersSignUp(data, (result) => {
                        if (result.code === 0) {
                            toast.success(t("계정이 등록되었습니다."), {
                                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                            });
                        } else {
                            toast.error(t("문제가 발생했습니다 관리자에게 문의하세요"), {
                                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                            });
                        }
                        dispatch(HistoryReducer.actions.setLoading(false));
                    });
                } else {
                    toast.error(t("pleaseCheck"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            })
        } else {
            toast.error(t("duplicateCheck"), {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            inputs.current[0].focus();
        }
    }

    return (
        <Container>
            <div className={styles.container}>
                <div className={styles.contentWrapper}>
                    <div className={styles.card}>
                        <div className={styles.header}>
                            <h1 className={styles.title}>파트너스 등록</h1>
                        </div>
                        
                        <div className={styles.formSection}>
                            <div className={styles.formRow}>
                                <div className={styles.formLabel}>
                                    <P>아이디</P>
                                </div>
                                <div className={styles.formInput}>
                                    <div className={styles.inputWithButton}>
                                        <div className={styles.inputField}>
                                            <InputText 
                                                ref={el => (inputs.current[0] = el)} 
                                                placeHolder={"아이디(3글자이상 20자 이하)"} 
                                                regExp={[textFormat]} 
                                            />
                                        </div>
                                        <CustomButton 
                                            text={"중복확인"} 
                                            onClick={onDuplicateClick} 
                                            className={styles.duplicateButton}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <div className={styles.formRow}>
                                <div className={styles.formLabel}>
                                    <P>비밀번호</P>
                                </div>
                                <div className={styles.formInput}>
                                    <InputPassword 
                                        ref={el => (inputs.current[1] = el)} 
                                        signUp 
                                        placeHolder={"비밀번호(대문자, 소문자, 숫자, 특수문자 포함)"} 
                                        placeHolderComfirm={t("password") + t("confirm")} 
                                        confirmVisible={true} 
                                        regExp={[passwordFormat]} 
                                    />
                                </div>
                            </div>
                            
                            <div className={styles.formRow}>
                                <div className={styles.formLabel}>
                                    <P>전화번호</P>
                                </div>
                                <div className={styles.formInput}>
                                    <InputText 
                                        ref={el => (inputs.current[2] = el)} 
                                        placeHolder={"전화번호"} 
                                        regExp={[mobileNoFormat]} 
                                    />
                                </div>
                            </div>
                            
                            <div className={styles.formRow}>
                                <div className={styles.formLabel}>
                                    <P>매장명</P>
                                </div>
                                <div className={styles.formInput}>
                                    <InputText 
                                        ref={el => (inputs.current[3] = el)} 
                                        placeHolder={"매장명"} 
                                        regExp={[textFormat]} 
                                    />
                                </div>
                            </div>
                            
                            <div className={styles.formRow}>
                                <div className={styles.formLabel}>
                                    <P>상점 코드</P>
                                </div>
                                <div className={styles.formInput}>
                                    <InputText 
                                        ref={el => (inputs.current[4] = el)} 
                                        placeHolder={"상점코드"} 
                                        regExp={[textFormat]} 
                                    />
                                </div>
                            </div>
                            
                            <div className={styles.buttonContainer}>
                                <CustomButton 
                                    text={"파트너스 등록"} 
                                    onClick={signUp} 
                                    className={styles.submitButton}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default PartnersRegister;